/* ==========================================================================
   stools2 — recently viewed products
   Records the current product (from [data-rv-current]) into localStorage and
   renders the list into every [data-recently-viewed] section. Pure client-side.
   ========================================================================== */

(function () {
  var KEY = 'stools_recently_viewed_v2';
  // flush legacy/demo entries from the old key
  try { localStorage.removeItem('stools_recently_viewed'); } catch (e) {}
  var MAX = 12;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch (e) {}
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // 1) Record the current product, if this page exposes one
  var currentEl = document.querySelector('[data-rv-current]');
  var current = null;
  if (currentEl) {
    try { current = JSON.parse(currentEl.getAttribute('data-rv-current')); } catch (e) {}
    if (current && current.handle) {
      var list = read().filter(function (p) { return p.handle !== current.handle; });
      list.unshift(current);
      write(list);
    }
  }

  // 2) Render into every recently-viewed section.
  // Fetch the real product-card markup per handle so cards are identical to the
  // rest of the site (size, hover, add-to-cart, quick view).
  document.querySelectorAll('[data-recently-viewed]').forEach(function (section) {
    var grid = section.querySelector('[data-rv-grid]');
    if (!grid) return;
    var items = read();
    if (current && current.handle) {
      items = items.filter(function (p) { return p.handle !== current.handle; });
    }
    var limit = parseInt(section.getAttribute('data-rv-limit'), 10) || 4;
    items = items.slice(0, limit);

    if (!items.length) { section.hidden = true; return; }
    section.hidden = false;

    Promise.all(items.map(function (p) {
      return fetch('/products/' + encodeURIComponent(p.handle) + '?section_id=rv-card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (htmls) {
      var frag = document.createDocumentFragment();
      htmls.forEach(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('.product-card');
        if (card) frag.appendChild(document.importNode(card, true));
      });
      if (frag.childNodes.length) {
        grid.innerHTML = '';
        grid.appendChild(frag);
      } else {
        section.hidden = true;
      }
    });
  });
})();
